import React from 'react'
import { CloseButton, Form } from 'react-bootstrap'
import styled from 'styled-components'
import { colors } from '../../styles/colors'
import { useLocalReceiptsState } from '../../stores/LocalReceiptsProvider'
import { useTranslation } from 'react-i18next'
import { formatedDate } from '../../utils/formatedDate'

const StyledWrapper = styled.div`
  //display: flex;
  flex-grow: 1;
  padding: 4px;

  .form-label {
    margin-bottom: 5px;
  }
`

const StyledItem = styled.div`
  margin: 5px;
  padding: 6px 10px;
  border: 1px solid ${colors.borderColor};
  border-radius: 8px;

  .close {
    margin-left: 15px;
  }
`

const StyledItemWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -5px;
`

const ActiveTableFilters = () => {
  const {
    supplierFilter, setSupplierFilter,
    storehouseFilter, setStorehouseFilter,
    startDateFilter, setStartDateFilter,
    endDateFilter, setEndDateFilter} = useLocalReceiptsState()

  const { t } = useTranslation()
  const formatedStartDate = () => {
    if(!!startDateFilter)
    {
        if (formatedDate(startDateFilter)) return formatedDate(startDateFilter)
    }
    return "";
  }
  const formatedEndDate = () => {
    if(!!endDateFilter)
    {
        if (formatedDate(endDateFilter)) return formatedDate(endDateFilter)
    }
    return "";
  }
  const startDate = formatedStartDate();
  const endDate = formatedEndDate();
  if (!supplierFilter && !storehouseFilter && !startDate && !endDate) {
    return null
  }
  return (
    <StyledWrapper>
      <Form.Label>{t('employeesPage:activeFilter')}</Form.Label>
      <StyledItemWrapper>
        {!!storehouseFilter && (
          <StyledItem><b>{t('goodsReceiptsTable:warehouseShortcut')}:</b> {storehouseFilter.displayName} <CloseButton
            onClick={() => { setStorehouseFilter(null) }} /></StyledItem>
        )}
        {!!supplierFilter && (
          <StyledItem><b>{t('goodsReceiptsTable:supplierShortcut')}:</b> {supplierFilter.displayName} <CloseButton
            onClick={() => { setSupplierFilter(null) }} /></StyledItem>
        )}
        {!!startDate && (
          <StyledItem><b>{t('from')}:</b> {startDate} <CloseButton
            onClick={() => { setStartDateFilter(null) }} /></StyledItem>
        )}
        {!!endDate && (
          <StyledItem><b>{t('to')}:</b> {endDate} <CloseButton
            onClick={() => { setEndDateFilter(null) }} /></StyledItem>
        )}
      </StyledItemWrapper>
    </StyledWrapper>
  )
}

export default ActiveTableFilters
